import { useState } from "react";
import { useAthleteAuthContext  } from "./useAthleteAuthContext";
import API_URL from '../../api/API';
import { Link,useNavigate } from "react-router-dom";



export const useAthleteLogin = () =>{

    const navigate = useNavigate();

    const [error,setError] = useState(null);
    const [isLoading,setIsLoading] = useState(null);
    const {dispatch} = useAthleteAuthContext();

    const athleteLogin = async (email,password) => {
        setIsLoading(true);
        setError(null);

        try {
            const response = await fetch(API_URL.POST_ATHLETE_LOGIN,{
                method: 'POST',
                headers: {'Content-Type' : 'application/json'},
                body: JSON.stringify({email,password})
            });
    
            const json = await response.json();
    
            if(!response.ok){
                setIsLoading(false);
                setError(json.error);
            }
    
            if(response.ok){
                //save the user to the local storage
                localStorage.setItem('athlete',JSON.stringify(json));
                dispatch({type:'ATHLETE_LOGIN',payload:json});
                setIsLoading(false);
                navigate('/athlete/dashboard');

            }
        } catch (error) {
            setError(error.message);
            setIsLoading(false);
        }

        
    }

    return {athleteLogin, isLoading, error};
}